import { DataProvider } from 'ra-core';
import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';

interface IFetchJson {
  status: number;
  headers: Headers;
  body: string;
  json: any;
}

export const httpClient = (url: string, options: fetchUtils.Options = {}): Promise<IFetchJson> => {
  const authParams = localStorage?.getItem('auth') || '';
  const { access_token } = JSON.parse(authParams);
  if (!access_token) throw new Error('ログインしてください');
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }

  options.user = {
    authenticated: true,
    token: access_token,
  };

  return fetchUtils.fetchJson(url, options);
};

// GraphQL client function
const executeGraphQLQuery = async (query: string, variables: any = {}) => {
  const authParams = localStorage?.getItem('auth') || '';
  const { access_token } = JSON.parse(authParams);
  if (!access_token) throw new Error('ログインしてください');

  const response = await fetch(`${apiUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  const json = await response.json();
  if (json.errors) {
    throw new Error(json.errors[0].message);
  }
  return json.data;
};

const apiUrl = process.env.REACT_APP_GRAPH_API_URL || '';
const defaultDataProvider: DataProvider = simpleRestProvider(apiUrl, httpClient);

export const dataProvider: DataProvider = {
  ...defaultDataProvider,

  getList: (resource, params) => {
    return defaultDataProvider.getList(resource, params);
  },

  getOne: async (resource, params) => {
    const response = await defaultDataProvider.getOne(resource, params);
    return { data: { ...response.data, id: response.data?.id || params.id } };
  },

  update: async (resource, params) => {
    if (params.meta?.gqlQuery) {
      const data = await executeGraphQLQuery(params.meta.gqlQuery, params.meta.variables);
      return { data };
    }

    const response = await defaultDataProvider.update(resource, params);
    return { data: { ...response.data, id: response.data?.id || params.id } };
  },

  delete: async (resource, params) => {
    // Check if GraphQL query is provided in meta
    if (params.meta?.gqlQuery) {
      const data = await executeGraphQLQuery(params.meta.gqlQuery, params.meta.variables);
      return { data };
    }

    // Fallback to default REST delete if no GraphQL query
    return defaultDataProvider.delete(resource, params);
  },

  // Add support for GraphQL mutations in create
  create: async (resource, params) => {
    if (params.meta?.gqlQuery) {
      const data = await executeGraphQLQuery(params.meta.gqlQuery, params.meta.variables);
      return { data };
    }
    return defaultDataProvider.create(resource, params);
  },

  // Add support for GraphQL mutations in update
  updateMany: async (resource, params) => {
    if (params.meta?.gqlQuery) {
      const data = await executeGraphQLQuery(params.meta.gqlQuery, params.meta.variables);
      return { data };
    }
    return defaultDataProvider.updateMany(resource, params);
  },

  deleteMany: async (resource, params) => {
    if (params.meta?.gqlQuery) {
      const data = await executeGraphQLQuery(params.meta.gqlQuery, params.meta.variables);
      return { data };
    }
    return defaultDataProvider.deleteMany(resource, params);
  },
};
